import { Tooltip } from "@chakra-ui/react";
import { useEffect, useState, useRef } from "react";
import { CgMenu as MenuIcon } from "react-icons/cg";
import { MdOutlineArrowBack as BackIcon } from "react-icons/md";
import { FiLogOut, FiSettings, FiUser, FiTarget, FiTrendingUp, FiActivity, FiGrid } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/routeKeys";
import ContractClose from "../../assets/icons/approve file.svg";
import Buyers from "../../assets/icons/buyers.svg";
import Companies from "../../assets/icons/companies.svg";
import Contacts from "../../assets/icons/contacts.svg";
import Exclusives from "../../assets/icons/exclusives.svg";
import Home from "../../assets/icons/home-outline.svg";
import Leads from "../../assets/icons/leads.svg";
import Offers from "../../assets/icons/offers.svg";
import pipeline from "../../assets/icons/pipeline.svg";
import Properties from "../../assets/icons/properties.svg";
import Proposals from "../../assets/icons/proposals.svg";
import Smart from "../../assets/icons/smart-plans.svg";
import Tasks from "../../assets/icons/tasks.svg";
import Logo from "../../assets/images/Logo.png";
import Logo2 from "../../assets/images/Logo2.png";
import LeftArrow from "../../assets/svgs/left-arrow.svg";
import RightArrow from "../../assets/svgs/right-arrow.svg";
import LogoutConfirmationModal from "../ConfirmationModals/LogoutConfirmationModal";
import {
  setConnectedAppData,
  setIsShowSettingSidebar,
  setIsSidebarCollapsed,
  setToken,
  setUserData,
  setUserType,
} from "../../redux/Action/AuthActions";
import { handleDropdownClose } from "../../utils/utils";
import "./Sidebar.css";

/* -------------------- NO UI CHANGE -------------------- */

const sidebarOptions = [
  { name: "Home", icon: Home, link: ROUTES.DASHBOARD },
  { name: "Contacts", icon: Contacts, link: ROUTES.CONTACTS },
  { name: "Companies", icon: Companies, link: ROUTES.COMPANIES },
  { name: "Properties", icon: Properties, link: ROUTES.PROPERTIES },
  { name: "Buyers", icon: Buyers, link: ROUTES.BUYERS, hasBottomBorder: true, specialClass: true },
  { name: "Tasks", icon: Tasks, link: ROUTES.TASKS },
  { name: "Pipeline", icon: pipeline, link: ROUTES.PIPELINE },
  { name: "Scorecard", icon: pipeline, link: "/scorecard" }, // missing from ROUTES perhaps
  { name: "TouchPlans", icon: Smart, link: ROUTES.TOUCH_PLANS, hasBottomBorder: true, specialClass: true },
  { name: "Leads", icon: Leads, link: ROUTES.LEADS },
  { name: "BOV", icon: Proposals, link: ROUTES.PROPOSALS },
  { name: "Exclusives", icon: Exclusives, link: ROUTES.EXCLUSIVES },
  { name: "Offers", icon: Offers, link: ROUTES.OFFERS },
  { name: "Contract to Close", icon: ContractClose, link: ROUTES.CONTACT_CLOSE },
  // { name: "Executed LOI", icon: Document, link: ROUTES.EXECUTED_LOI },
  // { name: "Under Contract", icon: Document, link: ROUTES.UNDER_CONTRACT },
  // { name: "Closed", icon: Document, link: ROUTES.CLOSED },
];

const settingOptions = [
  {
    title: "Archives",
    type: "dropdown",
    items: [
      { name: "Contact Archive", link: ROUTES.SETTINGS.CONTACT_ARCHIVE },
      { name: "Company Archive", link: ROUTES.SETTINGS.COMPANY_ARCHIVE },
      { name: "Property Archive", link: ROUTES.SETTINGS.PROPERTY_ARCHIVE },
      { name: "Buyer Archive", link: ROUTES.SETTINGS.BUYER_ARCHIVE },
      { name: "Exclusives Archive", link: ROUTES.SETTINGS.EXCLUSIVE_ARCHIVE },
      { name: "Executed LOI Archive", link: ROUTES.SETTINGS.EXECUTED_LOI_ARCHIVE },
      { name: "Under Contract Archive", link: ROUTES.SETTINGS.UNDER_CONTRACT_ARCHIVE },
      { name: "Contract To Close Archive", link: ROUTES.SETTINGS.CONTRACT_TO_CLOSED_ARCHIVE },
      { name: "Closed Archive", link: ROUTES.SETTINGS.CLOSED_ARCHIVE },
    ],
  },
  {
    title: "Tags",
    type: "dropdown",
    items: [
      { name: "Contact Tags", link: ROUTES.SETTINGS.CONTACT_TAGS },
      { name: "Company Tags", link: ROUTES.SETTINGS.COMPANY_TAGS },
      { name: "Property Tags", link: ROUTES.SETTINGS.PROPERTY_TAGS },
    ],
  },
  {
    type: "normal",
    items: [
      { name: "Users", link: ROUTES.USERS },
      { name: "Property Types", link: ROUTES.SETTINGS.PROPERTY_TYPES },
      { name: "Lead Sources", link: ROUTES.SETTINGS.LEAD_SOURCES },
      { name: "Lease Type", link: ROUTES.SETTINGS.LEAD_TYPE },
      { name: "Lead Round Robin", link: ROUTES.SETTINGS.LEAD_ROUND_ROBIN },
      { name: "Tenant", link: ROUTES.SETTINGS.TENANTS },
      { name: "Designated Agents", link: ROUTES.SETTINGS.DESIGNATED_AGENTS },
      { name: "Conversion Rate", link: ROUTES.SETTINGS.CONVERSION_RATE },
      { name: "ScoreCard History", link: ROUTES.SCORE_CARD_HISTORY },
      { name: "Connected App", link: ROUTES.SETTINGS.CONNECTED_APP },
      { name: "System Alerts", link: ROUTES.SETTINGS.SYSTEM_ALERTS },
      { name: "My Profile", link: ROUTES.SETTINGS.PROFILE },
      { name: "Activity Pulse", link: ROUTES.SETTINGS.LOGS },
    ],
  },
];

const salesOptions = [
  { name: "My Profile", icon: <FiUser className="w-4 h-4" />, link: ROUTES.SETTINGS.PROFILE },
  { name: "My Goals", icon: <FiTarget className="w-4 h-4" />, link: ROUTES.SCORE_CARD_HISTORY },
  { name: "Connected App", icon: <FiGrid className="w-4 h-4" />, link: ROUTES.SETTINGS.CONNECTED_APP },
  { name: "Conversion Rate", icon: <FiTrendingUp className="w-4 h-4" />, link: ROUTES.SETTINGS.CONVERSION_RATE },
  { name: "Activity Pulse", icon: <FiActivity className="w-4 h-4" />, link: ROUTES.SETTINGS.LOGS },
];

/* 🔑 ONLY ADDITION */
const dropdownRouteMap = {
  Archives: [
    "/settings/contact-archive",
    "/settings/company-archive",
    "/settings/property-archive",
    "/settings/buyer-archive",
    "/settings/exclusive-archive",
    "/settings/executedloi-archive",
    "/settings/undercontract-archive",
    "/settings/Contract-to-closed-archive",
    "/settings/closed-archive",
  ],
  Tags: [
    "/settings/contact-tags",
    "/settings/company-tags",
    "/settings/property-tags",
  ],
};

const SidebarComponent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userType = useSelector((state) => state.userType);
  const isSidebarCollapsed = useSelector((state) => state.isSidebarCollapsed);
  const isShowSettingSidebar = useSelector((state) => state.isShowSettingSidebar);
  const userDetails = useSelector((state) => state.userDetails);

  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const [openSetting, setOpenSetting] = useState(null);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  
  const salesMenuRef = useRef(null);
  const [isSalesMenuOpen, setIsSalesMenuOpen] = useState(false);

  useEffect(() => {
    const handleClose = () => setIsSalesMenuOpen(false);
    handleDropdownClose(salesMenuRef, handleClose);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

  const toggleSetting = (title) => {
    setOpenSetting(openSetting === title ? null : title);
  };

  const handleLogOut = () => {
    navigate(ROUTES.LOGIN);
    dispatch(setToken(null));
    dispatch(setUserType(null));
    dispatch(setUserData(null));
    dispatch(setConnectedAppData(null));
    dispatch(setIsShowSettingSidebar(false));
    localStorage.clear();
  };

  useEffect(() => {
    if (location.pathname.includes("settings")) {
      if (userType === 3) {
        dispatch(setIsShowSettingSidebar(false));
      } else {
        dispatch(setIsShowSettingSidebar(true));
      }
    } else {
      dispatch(setIsSidebarCollapsed(false));
      dispatch(setIsShowSettingSidebar(false));
    }
  }, [location.pathname, userType, dispatch]);

  /* ✅ FIX: keep dropdown open after selection */
  useEffect(() => {
    const currentPath = location.pathname;

    Object.entries(dropdownRouteMap).forEach(([title, routes]) => {
      if (routes.some(route => currentPath.startsWith(route))) {
        setOpenSetting(title);
      }
    });
  }, [location.pathname]);

  const sidebarList =
    userType === 3
      ? sidebarOptions.filter((el) => el.name !== "Users")
      : sidebarOptions;

  return (
    <>
      <button className="toggle-button" onClick={toggleSidebar}>
        {isSidebarVisible ? <BackIcon /> : <MenuIcon size={20} />}
      </button>

      <div className={`sidebar ${isSidebarCollapsed ? "collapsed" : ""} ${isShowSettingSidebar ? "setting-open" : ""} ${isSidebarVisible ? "visible" : ""}`}>
        <div 
          className={`${isSidebarCollapsed ? "top-section-collapsed" : "top-section"}`} 
          style={{ justifyContent: "center", alignItems: "center" }}
        >
          <div className="flex justify-center w-full">
            <NavLink to={ROUTES.DASHBOARD}>
              <img src={isSidebarCollapsed ? Logo2 : Logo} alt="Logo" />
            </NavLink>
          </div>

          {isShowSettingSidebar ? null : (
            <button
              style={isSidebarCollapsed ? { marginBottom: '4px', marginTop: '4px' } : { position: 'absolute', right: '14px' }}
              onClick={() => {
                dispatch(setIsSidebarCollapsed(!isSidebarCollapsed));
              }}
            >
              <img src={isSidebarCollapsed ? RightArrow : LeftArrow} alt="Collapse Icon" className="arrow-icon" />
            </button>
          )}
        </div>

        {isShowSettingSidebar ? (
          <ul className={`flex gap-1 ${isSidebarCollapsed ? "options-collapsed" : "options"} hide-scrollbar`} style={{ width: "100%" }}>
            <div style={{ width: "65px", minWidth: "65px" }} className={`middle_sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
              {sidebarList.map((option, index) => (
                <Tooltip key={index} placement="right" label={option.name}>
                  <li
                    onClick={() => {
                      dispatch(setIsShowSettingSidebar(false));
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""} ${option.hasBottomBorder ? "border-bottom" : ""} ${option.specialClass ? "special-class" : ""} ${option.setting_only ? "setting_only" : ""} ${option.blog_only ? "blog_only" : ""}`}
                  >
                    <NavLink 
                      to={option.link} 
                      className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`} 
                      activeclassname=""
                      style={isShowSettingSidebar ? { justifyContent: "center" } : {}}
                    >
                      <img src={option.icon} alt="icon" className="sidebar-icons" />
                    </NavLink>
                  </li>
                </Tooltip>
              ))}
            </div>

            <div className="flex-1 pl-2 pr-2 overflow-hidden" style={{ borderLeft: "1px solid #edf0eb" }}>
              <p className="dark-H head-4 pt-3">Settings</p>

              {settingOptions.map((section, index) => {
                // 🔹 DROPDOWN (Archives, Tags)
                if (section.type === "dropdown") {
                  return (
                    <div key={index}>
                      {/* Dropdown Header */}
                      <li
                        className={`option ${isSidebarCollapsed ? "w-fit" : ""} cursor-pointer`}
                        onClick={() => toggleSetting(section.title)}
                      >
                        <div className="option-link body-N">
                          <div className="flex items-center justify-between w-full">
                            <p className="text-left">{section.title}</p>
                            <span className="ml-2 text-[#6B7280] text-sm leading-none">
                              {openSetting === section.title ? "−" : "+"}
                            </span>
                          </div>
                        </div>
                      </li>

                      {/* Dropdown Items */}
                      {openSetting === section.title &&
                        section.items.map((option, i) => (
                          <li
                            key={i}
                            className={`option ${isSidebarCollapsed ? "w-fit" : ""}`}
                            onClick={() => {
                              localStorage.removeItem("filterData");
                              localStorage.removeItem("selectedSavefilterId");
                            }}
                          >
                            <NavLink
                              to={option.link}
                              className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`}
                            >
                              <p className="text-left">{option.name}</p>
                            </NavLink>
                          </li>
                        ))}
                    </div>
                  );
                }

                // 🔹 NORMAL ITEMS (NO "Others" heading)
                return section.items.map((option, i) => (
                  <li
                    key={`${index}-${i}`}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""}`}
                    onClick={() => {
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                  >
                    <NavLink
                      to={option.link}
                      className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`}
                    >
                      <p className="text-left">{option.name}</p>
                    </NavLink>
                  </li>
                ));
              })}
            </div>


          </ul>
        ) : (
          <ul className={`${isSidebarCollapsed ? "options-collapsed" : "options"} flex-1 overflow-y-auto overflow-x-hidden flex flex-col hide-scrollbar`} style={{ width: "100%", paddingBottom: "10px" }}>
            <div className={`middle_sidebar ${isSidebarCollapsed ? "collapsed" : ""}`}>
              {sidebarList.map((option, index) => (
                <Tooltip key={index} placement="right" isDisabled={isSidebarCollapsed === false || !isShowSettingSidebar === false} label={option.name}>
                  <li
                    onClick={() => {
                      dispatch(setIsShowSettingSidebar(false));
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                    className={`option ${isSidebarCollapsed ? "w-fit" : ""} ${option.hasBottomBorder ? "border-bottom" : ""} ${option.specialClass ? "special-class" : ""} ${option.setting_only ? "setting_only" : ""} ${option.blog_only ? "blog_only" : ""}`}
                  >
                    <NavLink to={option.link} className={`option-link body-N ${isSidebarCollapsed ? "collapsed" : ""}`} activeclassname="">
                      <img src={option.icon} alt="icon" className="sidebar-icons" />
                      {!isSidebarCollapsed && <p className="ml-3 body-N text-left">{option.children ? <>{option.name}</> : option.name}</p>}
                    </NavLink>
                  </li>
                </Tooltip>
              ))}
            </div>

          </ul>
        )}

        <div className={`mt-auto border-t w-full flex items-center p-2 relative ${isSidebarCollapsed && !isShowSettingSidebar ? "justify-center py-4" : "justify-between"}`} ref={salesMenuRef}>
          
          {/* Dropdown Menu for Sales User */}
          {isSalesMenuOpen && userType === 3 && (
            <div className="absolute bottom-full left-2 mb-2 w-48 green-bg-H rounded-lg shadow-lg overflow-hidden z-50">
              <ul className="py-2">
                {salesOptions.map((option, idx) => (
                  <li
                    key={idx}
                    onClick={() => {
                      setIsSalesMenuOpen(false);
                      navigate(option.link);
                      localStorage.removeItem("filterData");
                      localStorage.removeItem("selectedSavefilterId");
                    }}
                    className="flex items-center gap-3 px-4 py-2 hover:bg-black/20 cursor-pointer transition-colors group"
                  >
                    <div className="light-L">
                      {option.icon}
                    </div>
                    <p className="body-L light-L m-0 p-0 text-[13.5px] font-medium leading-none">{option.name}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {/* Profile Name (Clickable) */}
          {(!isSidebarCollapsed || isShowSettingSidebar) && (
            <div 
              className="flex items-center gap-1.5 cursor-pointer hover:bg-[#d1dbcf] hover:text-[#2d5b30] rounded p-1 flex-1 overflow-visible mr-1 transition-colors group" 
              onClick={() => {
                if (userType === 3) {
                  setIsSalesMenuOpen(!isSalesMenuOpen);
                } else {
                  navigate(ROUTES.SETTINGS.PROFILE);
                }
              }}
            >
              {userDetails?.profile_photo ? (
                <img src={userDetails.profile_photo} alt="user" className="w-7 h-7 rounded-full object-cover" />
              ) : (
                <div className="w-7 h-7 rounded-full bg-gray-200 flex items-center justify-center text-sm font-bold text-gray-600 flex-shrink-0">
                 {`${userDetails?.first_name?.[0] || ""}${userDetails?.last_name?.[0] || ""}`.toUpperCase()}
                </div>
              )}
              <p className="text-[13px] text-left font-semibold whitespace-nowrap capitalize text-gray-800 group-hover:text-[#2d5b30] tracking-tight transition-colors">
                {userDetails?.first_name} {userDetails?.last_name}
              </p>
            </div>
          )}
          
          {/* Action Icons */}
          <div className={`flex items-center ${(isSidebarCollapsed && !isShowSettingSidebar) ? "flex-col gap-4" : "gap-1"}`}>
            {userType !== 3 && (
              <Tooltip placement="top" label="Settings">
                <button 
                  onClick={() => {
                    dispatch(setIsShowSettingSidebar(true));
                    navigate(ROUTES.USERS);
                  }} 
                  className="p-1.5 hover:bg-[#d1dbcf] rounded-md transition-colors text-gray-500 hover:text-[#2d5b30]"
                >
                  <FiSettings className="w-5 h-5" />
                </button>
              </Tooltip>
            )}
            
            <Tooltip placement="top" label="Logout">
              <button 
                onClick={() => setShowLogoutModal(true)} 
                className="p-1.5 hover:bg-[#d1dbcf] rounded-md transition-colors text-red-400 hover:text-red-600"
              >
                <FiLogOut className="w-5 h-5" />
              </button>
            </Tooltip>
          </div>
        </div>
      </div>

      <LogoutConfirmationModal
        showModal={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
        handleLogout={handleLogOut}
      />
    </>
  );
};

export default SidebarComponent;
